var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!(_vm.$route.query['show-filter'] === 'false'))?_c('filters',{on:{"filter":_vm.filter,"search":_vm.search}}):_vm._e(),_c('restaurants-list',{attrs:{"restaurants":_vm.filteredRestaurants}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }